export default __webpack_public_path__ + "static/media/640_store01-it-mobile.3928816a.png";